import { makeStyles } from "@material-ui/core";
import { createCrudFormStyles } from "../../../common/forms/createCrudFormStyles";

export const useStyles = makeStyles(() =>
  createCrudFormStyles({
    errorFontSize: "14px !important",
    includeErrorMarginTop: true,
  })
);
